import React from 'react';

import { ComponentApplicationOptions } from 'models';

import { MultiSelectField, MultiSelectFieldProps } from 'components/forms/fields/MultiSelectField';

type ApplicationFieldProps = Omit<MultiSelectFieldProps, 'data'>;

const ApplicationField = (props: ApplicationFieldProps) => (
    <MultiSelectField {...props} data={Object.values(ComponentApplicationOptions)} />
);

export { ApplicationField };
